import { H } from 'highlight.run';

export const initializeHIGHLIGHT = () => {
    H.init('zg0qqne9', {
        tracingOrigins: true,
        networkRecording: {
            enabled: true,
            recordHeadersAndBody: true,
            urlBlocklist: [
                // insert urls you don't want to record here
            ],
        },
    });
}
